/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import LetterTemplateTableGrid from './LtTableGrid';
import { mfgHead } from './LtTableHead';
import { getManufacturerList,setLetterTemplateExtraState } from '../../store/actions';
import SelectBoxWithoutBoxComponent from '../../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import RadioGroupComponent from '../../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { REQUEST_DATE_INVALID_FORMAT_CBI } from '../../../../../SharedModules/Errors/constantMessageData';

const PreviewTemplateComp = (props) => {
  const { setLoading, filterValue, filterAction, onSelectRow } = props;
  const dispatch = useDispatch();
  const gridRef = React.useRef();
  const manufacturerList = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.manufacturerList
  );
  const extraState = useSelector(
      (state) => state.sharedState.LetterTemplateReducer.extraState
    );
  const setExtraState = (value) => dispatch(setLetterTemplateExtraState(value));
  const fullScreenView = useSelector(
      (state) =>
        state.sharedState.LetterTemplateReducer.extraState.fullScreenView
          .templateModal
    );
  const [mfgList, setMfgList] = React.useState([]);
  const [mfgCount, setMfgCount] = React.useState(0);
  const [qtrError, setQtrError] = React.useState(null);

  const filterPreviewTemplate = (value) => {
    setLoading(true);
    if (filterValue) {
      if (filterValue.selectedBy === 'MfgQtr' && filterValue.qtr) {
        dispatch(
          getManufacturerList({
            rebateProgramCd: filterValue.rebateProgramCd,
            ...value,
          })
        );
      }
    }
  };

  React.useEffect(() => {
    filterPreviewTemplate({ qtr: filterValue.qtr });
  }, []);

  React.useEffect(() => {
    setLoading(false);
    let list = [];
    if (manufacturerList) {
      if (
        manufacturerList.message === 'SUCESS' &&
        manufacturerList.status === '001'
      ) {
        list = manufacturerList.data || manufacturerList.createLetterMfgVO;
        list = !_.isEmpty(list) ? _.orderBy(list, ['mfgId'], ['asc']) : [];
      }
    }
    setMfgList(list);
  }, [manufacturerList]);

  const qtrValidation = (flType, val) => {
    let error = REQUEST_DATE_INVALID_FORMAT_CBI;
    if (val && val !== '' && !_.isNaN(val)) {
      const rgex = /[1-4]{1}[qQ]{1}\d{4}$/;
      const rgex1 = /[1-4]{1}[qQ]{1}\d{2}$/;
      if (rgex.test(val) || rgex1.test(val)) {
        const qtr = _.toUpper(val);
        filterAction(flType, qtr);
        filterPreviewTemplate({ qtr: qtr });
        error = null;
      }
    }
    setQtrError(error);
  };

  const setStateChange = (val) => {
    setExtraState({
      ...extraState,
      ...val,
    });
  };

  const changeFullScreenView = (view) => {
    const dataSet = {
      ...extraState.fullScreenView,
      templateModal: view,
    };
    setStateChange({ fullScreenView: dataSet });
  };
  return (
    <div
      className="lt-common-modal common-popup"
      data-testid="preview-letter-template-component"
    >
      <div className="p-3">
        <div className="row">
        {!fullScreenView && (
          <div className="col-12 frr-radio-100per-width mt-3">
            <RadioGroupComponent
              data-testid="action-redio-btn"
              id="action-radio-btn-action"
              labelName="Selection"
              required
              reqColor
              optionList={[
                { name: 'Manufacturer/Qtr', value: 'MfgQtr' },
                { name: 'Invoice Number', value: 'InvNum' },
              ]}
              defaultValue={filterValue.selectedBy}
              filterAction={(e) => filterAction('selectedBy', e)}
              className="log-batch-filter-radio"
            />
          </div>
        )}
          {filterValue.selectedBy === 'MfgQtr' && (
            <>
            {!fullScreenView && (
              <div className="col-12 frr-radio-100per-width mt-3">
                <fieldset className="selectBoxArea custom-fieldset">
                  <legend className="same-font-family">Rebate Program</legend>
                  <SelectBoxWithoutBoxComponent
                    data-testid="destination-rebate-program-select-box"
                    labelName=""
                    required={false}
                    select={false}
                    disabled
                    defaultValue={filterValue.rebateProgramCd}
                  />
                </fieldset>
              </div>
            )}
            {!fullScreenView && (
              <div className="col-12 frr-radio-100per-width mt-3">
                <SelectBoxWithoutBoxComponent
                  data-testid="destination-quarter-input-box"
                  labelName="Quarter"
                  required
                  select={false}
                  disabled={false}
                  defaultValue={filterValue.qtr}
                  filterAction={(e) => filterAction('qtr', e)}
                  onBlurAction={(e) => qtrValidation('qtr', e)}
                  isError={!_.isEmpty(qtrError) && qtrError}
                />
              </div>
            )}
              {/* <div className="col-12 frr-radio-100per-width">
                <div className="float-right mt-2 hide-on-print">
                  <Button
                    className="btn btn-success btn-search"
                    data-testid="filter-manufacturer-list-btn"
                    onClick={filterPreviewTemplate}
                  >
                    Filter
                  </Button>
                </div>
              </div> */}

              <div className="col-12 frr-radio-100per-width">
                <LetterTemplateTableGrid
                  data-testid="destination-manufacturer-table"
                  gridRef={gridRef}
                  cellHead={mfgHead}
                  dataList={mfgList}
                  gridHeight={fullScreenView ? '70vh' : 350}
                  fileName="Manufaturer List"
                  fullScreenViewTable="Manufaturer List"
                  setFullScreenView={() => changeFullScreenView(!fullScreenView)}
                  fullScreenView={fullScreenView}
                  filterIcon
                  tableHeader
                  actionIcon
                  setTotalResultCount={setMfgCount}
                  onSelect={(e) => onSelectRow(e.data)}
                  onCellKeyDown={(e) => {
                    if (e.event.key === 'Enter') {
                      onSelectRow(e.data);
                    }
                  }}
                  childPopup
                />
                {/* <p className="total-results" tabIndex="0">
                  Total Results:
                  <b>{mfgCount}</b>
                </p> */}
              </div>
            </>
          )}

          {filterValue.selectedBy === 'InvNum' && (
            <div className="col-12 frr-radio-100per-width mt-3">
              <SelectBoxWithoutBoxComponent
                data-testid="destination-invoice-number-box"
                labelName="Invoice Number"
                required
                select={false}
                disabled={false}
                defaultValue={filterValue.InvNum}
                filterAction={(e) => {
                  const rg = /^[0-9]*$/;
                  if (rg.test(e)) {
                    filterAction('InvNum', e);
                  }
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default PreviewTemplateComp;
